import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Spin } from "antd";

import type { RootState } from "../../store/store";
import { HomePageTitle } from "./parts/homePageTitle";
import { SearchWalletInput } from "./parts/searchWalletInput";
import { StakeInfoTable } from "../../components/StakeInfo";
import { WhiteListTable } from "../../components/WhiteListInfo";
import { TableTitle } from "../../components/TableTitle";
import { LotteryInfoTable } from "../../components/LotteryInfo";
import { ClaimInfoTable } from "../../components/ClaimInfo";
import { ETHInfoTable } from "../../components/EthBridgeInfo";
import { BscInfoTable } from "../../components/BscBridgeInfo";

import "./home.scss";
import { AllStakeInfoTable } from "../../components/AllStakingInfo";

export const HomePage: FC = () => {
  const {
    stakingInfo,
    allStakingInfo,
    stakingInfoLoader,
    whitelistInfo,
    whitelistLoader,
    lotteryInfo,
    lotteryInfoLoader,
    claimInfo,
    claimInfoLoader,
    EthbridgeInfo,
    EthBridgeInfoLoader,
    BscbridgeInfo,
    BscBridgeInfoLoader,
    userInfo,
  } = useSelector((s: RootState) => s.homePage);

  return (
    <>
      <HomePageTitle />
      <SearchWalletInput />

      {stakingInfoLoader ? (
        <div>
          <Spin />
        </div>
      ) : (
        <>
          {stakingInfo && userInfo && stakingInfo.lastStake && (
            <>
              <TableTitle tableName={"Staking Details"} />
              <StakeInfoTable {...stakingInfo} {...userInfo} />
            </>
          )}
        </>
      )}

      {stakingInfoLoader ? (
        <div>
          <Spin />
        </div>
      ) : (
        <>
          {allStakingInfo && allStakingInfo?.length > 0 && (
            <>
              <TableTitle tableName={"All Staking Details"} />
              {allStakingInfo.map((singleStakeInfo, index) => {
                return (
                  <>
                    {/* eslint-disable-next-line */}
                    <AllStakeInfoTable {...singleStakeInfo} key={index} />
                    <div style={{ marginTop: "20px" }} />
                  </>
                );
              })}
            </>
          )}
        </>
      )}

      {whitelistLoader ? (
        <div>
          <Spin />
        </div>
      ) : (
        <>
          {whitelistInfo.length > 0 && (
            <>
              <TableTitle tableName={"Whitelist Details"} />
              {whitelistInfo.map((n) => (
                <>
                  <WhiteListTable
                    {...n}
                    // eslint-disable-next-line
                    key={`white-list-row-${n.projectId}`}
                  />
                  <div style={{ marginTop: "5px" }} />
                </>
              ))}
            </>
          )}
        </>
      )}

      {lotteryInfoLoader ? (
        <div>
          <Spin />
        </div>
      ) : (
        <>
          {lotteryInfo.length > 0 && (
            <>
              <TableTitle tableName={"Project Details"} />
              {lotteryInfo.map((n) => (
                <>
                  <LotteryInfoTable
                    {...n}
                    // eslint-disable-next-line
                    key={`lottery-list-row-${n.projectId}`}
                  />
                  <div style={{ marginTop: "5px" }} />
                </>
              ))}
            </>
          )}
        </>
      )}

      {claimInfoLoader ? (
        <div>
          <Spin />
        </div>
      ) : (
        <>
          {claimInfo.length > 0 && (
            <>
              <TableTitle tableName={"Claim Details"} />
              {claimInfo.map((n) => (
                <>
                  <ClaimInfoTable
                    {...n}
                    // eslint-disable-next-line
                    key={`claim-list-row-${n.txHash}`}
                  />
                  <div style={{ marginTop: "5px" }} />
                </>
              ))}
            </>
          )}
        </>
      )}

      {EthBridgeInfoLoader ? (
        <div>
          <Spin />
        </div>
      ) : (
        <>
          {EthbridgeInfo.length > 0 && (
            <>
              <TableTitle tableName={"ETH Bridge Details"} />
              {EthbridgeInfo.map((n) => (
                <>
                  <ETHInfoTable
                    {...n}
                    // eslint-disable-next-line
                    key={`claim-list-row-${n.txHash}`}
                  />
                  <div style={{ marginTop: "5px" }} />
                </>
              ))}
            </>
          )}
        </>
      )}

      {BscBridgeInfoLoader ? (
        <div>
          <Spin />
        </div>
      ) : (
        <>
          {BscbridgeInfo.length > 0 && (
            <>
              <TableTitle tableName={"BSC Bridge Details"} />
              {BscbridgeInfo.map((n) => (
                <>
                  <BscInfoTable
                    {...n}
                    // eslint-disable-next-line
                    key={`claim-list-row-${n.txHash}`}
                  />
                  <div style={{ marginTop: "5px" }} />
                </>
              ))}
            </>
          )}
        </>
      )}
    </>
  );
};
